import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '../api';

/**
 * Один клієнт запитів на застосунок. Кеш привʼязаний до сесії: при вході, виході і завершенні сесії
 * його очищаємо (stores/auth), інакше наступна людина в тому ж браузері бачила б дані попередньої
 * ролі (довідник /meta, списки) до першого оновлення.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        if (isApiError(err) && err.status > 0 && err.status < 500) return false;
        return count < 2;
      },
    },
  },
});
